import { TrashIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';

import ConfirmableButton from '../ConfirmableButton';

import BookingCell from './BookingCell';
import { ColumnConfig, ColumnKey, ExtendedDatevBookingData } from './constants';

interface BookingRowProps {
  entry: ExtendedDatevBookingData;
  index: number;
  isEditing: boolean;
  columns: ColumnConfig[];
  visibleColumns: Set<ColumnKey>;
  onRemove: (index: number) => void;
  onChangeCell: (
    index: number,
    field: ColumnKey,
    value: string | number | null
  ) => void;
  formatCurrency: (amount: number) => string;
}

const BookingRow: React.FC<BookingRowProps> = ({
  entry,
  index,
  isEditing,
  columns,
  visibleColumns,
  onRemove,
  onChangeCell,
  formatCurrency,
}) => {
  const [isConfirmingDelete, setIsConfirmingDelete] = useState(false);

  return (
    <tr className='hover:bg-gray-50 group'>
      <td className='px-3 py-2 text-sm text-gray-600 border-r border-gray-200 relative whitespace-nowrap text-center'>
        <span className={isEditing ? (isConfirmingDelete ? 'hidden' : 'group-hover:hidden') : ''}>
          {index + 1}
        </span>

        {isEditing && (
          <div
            className={
              isConfirmingDelete ? 'inline-block ml-1' : 'hidden group-hover:inline-block'
            }
          >
            <ConfirmableButton
              onConfirm={() => onRemove(index)}
              onShowConfirmation={setIsConfirmingDelete}
              buttonClassName='p-0.5 bg-white rounded-full border border-gray-300 text-red-600 hover:text-red-800 hover:border-red-600 shadow-sm'
            >
              <TrashIcon className='w-3 h-3' />
            </ConfirmableButton>
          </div>
        )}
      </td>

      {columns.map(
        config =>
          visibleColumns.has(config.key) && (
            <BookingCell
              key={config.key}
              entry={entry}
              field={config.key}
              isEditing={isEditing}
              columnConfig={config}
              onChange={(field, value) => onChangeCell(index, field, value)}
              formatCurrency={formatCurrency}
            />
          )
      )}
    </tr>
  );
};

export default BookingRow;
